import {ListItemText as MUIListItemText} from '@mui/material'

export const ListItemText = MUIListItemText
